<template>
	<main>
		<div class="py-12">
			<div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
				<h1
					class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
				>
					Übersicht
				</h1>
				<div class="flex items-center">
					<div class="ml-auto">
						<router-link
							to="/url/create"
							class="inline-flex items-center px-4 py-2 bg-primary border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-primary-light focus:outline-none focus:border-primary-light focus:ring focus:ring-gray-300 disabled:opacity-25 transition"
						>
							Verkürzung erstellen
						</router-link>
					</div>
				</div>
				<div class="bg-white shadow-xl sm:rounded-lg mt-6 px-6 py-6">
					<table id="data-table" style="width: 100%">
						<thead>
							<tr>
								<th class="p-3 text-left bg-white">
									Angelegt am
								</th>
								<th class="p-3 text-left bg-white">Titel</th>
								<th class="p-3 text-left bg-white">Link</th>
								<th class="p-3 text-left bg-white">QR Codes</th>
								<th class="p-3 text-left bg-white">Aufrufe</th>
								<th class="p-3 text-right bg-white">
									Aktionen
								</th>
							</tr>
						</thead>
					</table>
				</div>
			</div>
		</div>
		<div
			class="main-modal modal-wrapper overflow-auto fixed w-full inset-0 z-50 flex justify-center items-center animated fadeIn faster"
			style="background: rgba(0,0,0,.7);"
		>
			<div
				class="bg-white modal-container overflow-hidden shadow-xl sm:rounded-lg mt-6"
			>
				<div class="py-4 px-6">
					<div class="flex justify-between items-center pb-3">
						<p class="text-2xl font-bold text-gray-500">QR Codes</p>
						<div
							class="modal-close cursor-pointer z-50"
							@click="modalClose('main-modal')"
						>
							<svg
								class="fill-current text-gray-500"
								xmlns="http://www.w3.org/2000/svg"
								width="18"
								height="18"
								viewBox="0 0 18 18"
							>
								<path
									d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
								></path>
							</svg>
						</div>
					</div>
					<div class="my-5 mr-5 ml-5">
						<form-label for="qr-code" value="Format"></form-label>
						<form-input
							id="qr-code-type"
							type="select"
							:options="[
								{ value: 'png', label: 'PNG' },
								{ value: 'svg', label: 'SVG' },
							]"
							class="mt-1 mb-2 block w-full"
							v-model="selectedQRType"
						></form-input>
						<form-label for="qr-code" value="Größe"></form-label>
						<form-input
							id="qr-code-size"
							type="select"
							:options="[
								{ value: 13, label: 'Groß' },
								{ value: 5, label: 'Klein' },
							]"
							class="mt-1 block w-full"
							v-model="selectedQRSize"
						></form-input>
						<a :href="'https://go2.nuernberg.de/qrcode.php?download=true&url=' +
										encodeURI(selectedUrlLink) +
										'&size=' +
										selectedQRSize + '&type=' + selectedQRType" class="block mt-2 px-4 py-2 bg-primary border border-transparent rounded-md font-semibold text-xs text-white text-center uppercase tracking-widest hover:bg-primary-light focus:outline-none focus:border-primary-light focus:ring focus:ring-gray-300 disabled:opacity-25 transition">Download</a>
						<div class="mt-4 flex justify-center">
							<img
								:src="
									'https://go2.nuernberg.de/qrcode.php?url=' +
										encodeURI(selectedUrlLink) +
										'&size=' +
										selectedQRSize + '&type=' + selectedQRType
								"
								alt="QR Code"
								title="QR Code"
							/>
						</div>
					</div>
				</div>
				<div class="px-6 py-4 bg-gray-100 text-right">
					<form-button
						:type="button"
						@click="modalClose('main-modal')"
						>Schließen</form-button
					>
				</div>
			</div>
		</div>

		<div
			class="delete-modal modal-wrapper overflow-auto fixed w-full inset-0 z-50 flex justify-center items-center animated fadeIn faster"
			style="background: rgba(0,0,0,.7);"
		>
			<div
				class="bg-white modal-container overflow-hidden shadow-xl sm:rounded-lg mt-6"
			>
				<div class="py-4 px-6">
					<div class="flex justify-between items-center pb-3">
						<p class="text-2xl font-bold text-gray-500">
							Verkürzung löschen
						</p>
						<div
							class="modal-close cursor-pointer z-50"
							@click="modalClose('delete-modal')"
						>
							<svg
								class="fill-current text-gray-500"
								xmlns="http://www.w3.org/2000/svg"
								width="18"
								height="18"
								viewBox="0 0 18 18"
							>
								<path
									d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
								></path>
							</svg>
						</div>
					</div>
					<div class="my-5 mr-5 ml-5 flex justify-center">
						Möchten Sie URL Verkürzung "{{ selectedUrlTitle }}"
						wirklich löschen?
					</div>
				</div>
				<div class="px-6 py-4 bg-gray-100 text-right">
					<form-button
						:type="button"
						button="secondary"
						@click="modalClose('delete-modal')"
						>Schließen</form-button
					>
					<form-button :type="button" @click="deleteUrl" class="ml-2"
						>Löschen</form-button
					>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
	import "datatables.net-responsive";
	import "datatables.net-fixedheader";
	import "datatables.net-dt/js/dataTables.dataTables";
	import "datatables.net-dt/css/jquery.dataTables.min.css";
	import FormLabel from "@/components/FormLabel";
	import FormInput from "@/components/FormInput";
	import UrlService from "@/services/url.js";
	import FormButton from "@/components/FormButton";
	import $ from "jquery";

	let dataTable;

	$.fn.dataTable.defaults.language = {
		sEmptyTable: "Keine Daten in der Tabelle vorhanden",
		sInfo: "_TOTAL_ Einträge",
		sInfoEmpty: "0 bis 0 von 0 Einträgen",
		sInfoFiltered: "(gefiltert von _MAX_ Einträgen)",
		sInfoPostFix: "",
		sInfoThousands: "",
		sLengthMenu: "_MENU_ Einträge anzeigen",
		sLoadingRecords: "Wird geladen...",
		sProcessing: "Bitte warten...",
		sSearch: "",
		searchPlaceholder: "Tabelle durchsuchen",
		sZeroRecords: "Keine Einträge vorhanden",
		oPaginate: {
			sFirst: "Erste",
			sPrevious: "Zurück",
			sNext: "Nächste",
			sLast: "Letzte",
		},
		oAria: {
			sSortAscending: ": aktivieren, um Spalte aufsteigend zu sortieren",
			sSortDescending: ": aktivieren, um Spalte absteigend zu sortieren",
		},
	};

	export default {
		components: {
			FormButton,
			FormLabel,
			FormInput,
		},
		data() {
			return {
				rows: [],
				selectedUrlTitle: "",
				selectedUrlId: null,
				selectedUrlLink: "",
				selectedQRSize: 13,
				selectedQRType: 'png'
			};
		},
		async created() {
			this.loadUrlOverview();
		},
		beforeUnmount() {
			dataTable.destroy();
			$(document).off("click", "#data-table .copy-link");
			$(document).off("click", "#data-table .dropdown button");
			$(document).off("click", "#data-table .open-qr-codes");
			$(document).off("click", "#data-table .crud-link");
		},
		mounted() {
			let _this = this;

			const all_modals = ["main-modal", "delete-modal"];
			all_modals.forEach((modal) => {
				let modalSelected = document.querySelector("." + modal);
				modalSelected.classList.remove("fadeIn");
				modalSelected.classList.add("fadeOut");
				modalSelected.style.display = "none";
			});

			$(document).ready(function() {
				$(document).on("click", "#data-table .copy-link", function(e) {
					e.preventDefault();

					let targetRow = $(this).parents("tr");
					if (targetRow.hasClass("child")) {
						targetRow = targetRow.prev();
					}

					let data = dataTable.row(targetRow).data();
					_this.copyLinkToClipboard(data.link);
				});

				$(document).on(
					"click",
					"#data-table .dropdown button",
					function(e) {
						e.preventDefault();

						let items = $(this)
							.parents(".dropdown")
							.find(".dropdown-items");
						if (items.hasClass("hidden")) {
							items.removeClass("hidden");
							items.removeClass('z-0').addClass('z-10');
						} else {
							items.addClass("hidden");
							items.removeClass('z-10').addClass('z-0');
						}
					}
				);

				$(document).on("click", "#data-table .open-qr-codes", function(
					e
				) {
					e.preventDefault();

					let targetRow = $(this).parents("tr");
					if (targetRow.hasClass("child")) {
						targetRow = targetRow.prev();
					}

					let data = dataTable.row(targetRow).data();
					_this.openQRCodes(data.link);
				});

				$(document).on("click", "#data-table .crud-link", function(e) {
					e.preventDefault();
					let type = $(this).data("type");

					let targetRow = $(this).parents("tr");
					if (targetRow.hasClass("child")) {
						targetRow = targetRow.prev();
					}

					let data = dataTable.row(targetRow).data();

					if (type == "delete") {
						_this.deleteUrlModal(
							data.id,
							data.title,
							$(this).parents("tr")
						);
					} else {
						_this.$router.push("/url/" + type + "/" + data.id);
					}
				});
			});
		},
		methods: {
			copyLinkToClipboard(link) {
				const el = document.createElement("textarea");
				el.value = link;
				document.body.appendChild(el);
				el.select();
				document.execCommand("copy");
				document.body.removeChild(el);
			},
			openQRCodes(link) {
				this.selectedUrlLink = link;
				this.modalOpen("main-modal");
			},
			deleteUrlModal(id, title, index) {
				this.selectedUrlTitle = title;
				this.selectedUrlId = id;
				this.selectedUrlIndex = index;
				this.modalOpen("delete-modal");
			},
			deleteUrl() {
				let _this = this;

				if (_this.selectedUrlId) {
					_this.$emit("update-loading-overlay", true);

					UrlService.delete({
						id: _this.selectedUrlId,
					}).then((response) => {
						if (response.success) {
							_this.$emit("show-toast", {
								message: "Verkürzung erfolgreich gelöscht!",
								type: "success",
							});
							dataTable
								.row(_this.selectedUrlIndex)
								.remove()
								.draw();
						} else {
							_this.$emit("show-toast", {
								message: response.message,
								type: "error",
							});
						}

						_this.modalClose("delete-modal");
						_this.selectedUrlTitle = "";
						_this.selectedUrlId = null;
						_this.selectedUrlIndex = null;

						_this.$emit("update-loading-overlay", false);
					});
				}
			},
			loadUrlOverview() {
				let _this = this;

				_this.$emit("update-loading-overlay", true);

				UrlService.overview()
					.then((response) => {
						for (let id in response.data) {
							let url = response.data[id];
							url["link"] =
								"https://" + url.domain + "/" + url.slug;
						}

						_this.rows = response.data;

						dataTable = $("#data-table").DataTable({
							data: _this.rows,
							responsive: true,
							fixedHeader: true,
							ordering: true,
							order: [[0, "desc"]],
							searching: true,
							paging: false,
							bLengthChange: false,
							createdRow: function(row, data, index) {
								$(row)
									.find("td")
									.each(function(i, td) {
										$(td).attr("tabindex", 0);
									});
							},
							columns: [
								{
									title: "Angelegt am",
									responsivePriority: 4,
									data: "created_at",
									render: function(data, type, row, meta) {
										if (type == "display") {
											return row["created_at_label"];
										}

										return data;
									},
								},
								{
									title: "Titel",
									responsivePriority: 1,
									data: "title",
									render: function(data, type, row, meta) {
										if (type == "display") {
											var linkTitle = data;
											if (linkTitle.length > 60) {
												linkTitle = linkTitle.substr(0, 60) + '...'
											}
											return `<span title="${row.link}">${linkTitle}</span>`;
										}

										return data;
									}
								},
								{
									title: "Link",
									responsivePriority: 3,
									data: "link",
									render: function(data, type, row, meta) {
										if (type == "display") {
											return `<div class="inline-flex">
											<a
											href="#"
											class="copy-link"
											title="Link kopieren"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												class="h-5 w-5 text-primary"
												viewBox="0 0 20 20"
												fill="currentColor"
											>
												<path
													d="M8 2a1 1 0 000 2h2a1 1 0 100-2H8z"
												/>
												<path
													d="M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z"
												/>
											</svg>
											</a> 
											<span class="mr-2">${row.link}</span>
											</div>`;
										}

										return data;
									},
								},
								{
									title: "QR Codes",
									responsivePriority: 6,
									searchable: false,
									orderable: false,
									data: "link",
									render: function(data, type, row, meta) {
										if (type == "display") {
											return `<a
											href="#"
											class="open-qr-codes"
											title="QR Codes anzeigen"
											>QR Codes anzeigen</a
										>`;
										}

										return data;
									},
								},
								{
									title: "Aufrufe",
									responsivePriority: 5,
									data: "clicks",
								},
								{
									title: "Aktionen",
									responsivePriority: 2,
									data: "id",
									searchable: false,
									orderable: false,
									render: function(data, type, row, meta) {
										if (type == "display") {
											return `
											<div class="flex justify-end">
											<a href="#"
												class="mr-2 crud-link"
												data-type="statistics"
												><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
</svg></a>

											<div class="dropdown relative inline-block text-left">
  <div class="flex items-center">
    <button type="button" id="menu-button" class="text-primary" aria-expanded="true" aria-haspopup="true">
      <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true">
        <path xmlns="http://www.w3.org/2000/svg" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"/>
      </svg>
    </button>
  </div>
  <div class="dropdown-items hidden origin-top-right absolute right-0 mt-2 w-auto z-0 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
    <div class="py-1" role="none">
      <a href="#" class="text-gray-700 block px-4 py-2 text-sm crud-link" data-type="read" role="menuitem" tabindex="-1">Details</a>
      <a href="#" class="text-gray-700 block px-4 py-2 text-sm crud-link" data-type="update" role="menuitem" tabindex="-1">Bearbeiten</a>
      <a href="#" class="text-gray-700 block px-4 py-2 text-sm crud-link" data-type="history" role="menuitem" tabindex="-1">Historie</a>
      <a href="#" class="text-gray-700 block px-4 py-2 text-sm crud-link" data-type="logs" role="menuitem" tabindex="-1">Log-Einträge</a>
      <a href="#" class="text-gray-700 block px-4 py-2 text-sm crud-link" data-type="delete" role="menuitem" tabindex="-1">Löschen</a>
    </div>
  </div>
</div>
</div>`;
										}
										return data;
									},
								},
							],
						});
						$("#data-table_filter")
							.removeClass("dataTables_filter")
							.addClass("mb-4")
							.find("input")
							.addClass(
								"border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
							);
						_this.$emit("update-loading-overlay", false);
					})
					.catch((error) => {
						_this.$emit("show-toast", {
							message: error,
							type: "error",
						});
						console.log(error);

						_this.$emit("update-loading-overlay", false);
					});
			},
			modalClose(modal) {
				let modalToClose = document.querySelector("." + modal);
				modalToClose.classList.remove("fadeIn");
				modalToClose.classList.add("fadeOut");
				document.querySelector("body").classList.remove("h-screen");
				document
					.querySelector("body")
					.classList.remove("overflow-hidden");

				if (modal == "main-modal") {
					this.selectedQRSize = 13;
					this.selectedQRType = 'png';
				}

				setTimeout(() => {
					modalToClose.style.display = "none";
				}, 500);
			},
			modalOpen(modal) {
				let modalToOpen = document.querySelector("." + modal);
				modalToOpen.classList.remove("fadeOut");
				modalToOpen.classList.add("fadeIn");
				document.querySelector("body").classList.add("h-screen");
				document.querySelector("body").classList.add("overflow-hidden");
				modalToOpen.style.display = "flex";
			},
		},
	};
</script>
